module.exports = __webpack_public_path__ + "img/es.728545a2.png";